var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSearch({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    overflow: "visible",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_476",
    fill: "#FFFFFF",
    d: "M7.8,12.5c-2.6,0-4.7-2.1-4.7-4.7c0,0,0,0,0,0c0-2.6,2.1-4.7,4.7-4.7c0,0,0,0,0,0 c2.6,0,4.7,2.1,4.7,4.7c0,0,0,0,0,0c0,0.7-0.2,1.4-0.5,2.1c-0.5,1-1.2,1.7-2.2,2.2C9.2,12.3,8.5,12.5,7.8,12.5L7.8,12.5z M14.3,12.1 c0.9-1.3,1.3-2.8,1.3-4.3c0-4.3-3.5-7.8-7.8-7.8C3.5,0,0,3.5,0,7.8c0,4.3,3.5,7.8,7.8,7.8c1.5,0,3-0.4,4.3-1.3l5.7,5.7l0.1,0.1 l0.1-0.1l2.1-2.1L14.3,12.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearch);
export default __webpack_public_path__ + "static/media/icon_search.fa679d31149704eb624d85caac6f5407.svg";
export { ForwardRef as ReactComponent };